import { _apiRequestWrap } from '@/services/apiService.js'

export default class ApiModule {
	constructor(moduleName, params) {
		this.apiRequestWrap = _apiRequestWrap
		this.moduleName = moduleName
		this.params = Object.assign({
			entity: 'entity',
			parentEntity: null,
			entityGroup: null, // добавление группы без указание id. пример: 'weighing'
			useExtraSingleLoadingMethod: true,
		}, params)
	}

	generateUrl(addEntityId = false, params) {
		const _params = Object.assign({
			suffix: null,
		}, params)
		let url = `/company/:companyId/`
		if (this.params.parentEntity) url += `${this.params.parentEntity}/:parentId/`
		if (this.params.entityGroup) url += `${this.params.entityGroup}/`
		if (this.params.entity) url += `${this.params.entity}/`
		if (addEntityId) url += `:entityId/`
		if (_params.suffix) url += `${_params.suffix}/`
		return url
	}

	getEntities(options = {}) {

		const config = {
			url: this.generateUrl(),
		}

		return _apiRequestWrap(this.moduleName, config, options)
	}

	createEntity(options = {}) {

		const config = {
			url: this.generateUrl(),
			requestOptions: {
				method: 'POST',
			},
		}

		return _apiRequestWrap(this.moduleName, config, options)
	}

	getEntity(options = {}) {

		const config = {
			url: this.generateUrl(true),
		}

		return _apiRequestWrap(this.moduleName, config, options)
	}

	getEntityPopup(options = {}) {

		if (!this.params.useExtraSingleLoadingMethod) {
			return this.getEntity(options)
		}

		const config = {
			url: this.generateUrl(true, {
				suffix: 'popup',
			}),
		}

		return _apiRequestWrap(this.moduleName, config, options)
	}

	getEntityPreview(options = {}) {

		if (!this.params.useExtraSingleLoadingMethod) {
			return this.getEntity(options)
		}

		const config = {
			url: this.generateUrl(true, {
				suffix: 'preview',
			}),
		}

		return _apiRequestWrap(this.moduleName, config, options)
	}

	patchEntity(options = {}) {

		const config = {
			url: this.generateUrl(true),
			requestOptions: {
				method: 'PATCH',
			},
		}

		return _apiRequestWrap(this.moduleName, config, options)
	}

	putEntity(options = {}) {

		const config = {
			url: this.generateUrl(true),
			requestOptions: {
				method: 'PUT',
			},
		}

		return _apiRequestWrap(this.moduleName, config, options)
	}

	deleteEntity(options = {}) {

		const config = {
			url: this.generateUrl(true),
			requestOptions: {
				method: 'DELETE',
			},
		}

		return _apiRequestWrap(this.moduleName, config, options)
	}

}
